export enum BulletType {
  DANGER = 1,
  MEDIUM = 2,
  LOW = 3,
}

export const EMPTY_SEVERITY_SCORE = '__';
